//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

import StencilMode from '../../gl/stencil_mode';
const ALWAYS = 0x0207;
const KEEP = 0x1E00;
const REPLACE = 0x1E01;
const EQUAL = 0x0202;
const ZERO = 0;
export const beginGeojsonStencil = new StencilMode({ func: ALWAYS, mask: 0xFF }, 25, 0xFF, ZERO, ZERO, REPLACE);
export const endGeojsonStencil = new StencilMode({ func: EQUAL, mask: 0xFF }, 25, 0x00, KEEP, KEEP, KEEP);

